(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9564],{

/***/ 72653:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections",
      function () {
        return __webpack_require__(6696);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShowMoreButtonWithIcon; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
;// CONCATENATED MODULE: ./components/icons/Collections/ShowMoreArrow.tsx





function ShowMoreIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "12",
        viewBox: "0 0 24 12",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M2 2.5L11.7436 9.55882L22 2.5",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./components/form/resources/ShowMoreButtonWithIcon.tsx





function ShowMoreButtonWithIcon(param) {
    var loading = param.loading, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
        variant: "secondary",
        loading: loading,
        size: "sm",
        rightIcon: ShowMoreIcon,
        onClick: onClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            id: "aWpBzj",
            defaultMessage: "Show more"
        })
    });
};


/***/ }),

/***/ 19805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleBookmark($targetId: ObjectId!, $targetType: BookmarkType!) {\n    toggleBookmark(targetId: $targetId, targetType: $targetType) {\n      __typename\n      ... on Product {\n        _id\n        viewerDidBookmark\n      }\n      ... on Story {\n        _id\n        viewerDidBookmark\n      }\n      ... on Project {\n        _id\n        viewerDidBookmark\n      }\n      ... on GovernmentPost {\n        _id\n        viewerDidBookmark\n      }\n      ... on GroupPost {\n        _id\n        viewerDidBookmark\n      }\n      ... on VendorPost {\n        _id\n        viewerDidBookmark\n      }\n      ... on Collection {\n        _id\n        viewerDidBookmark\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 91760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ stripUndefined; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56365);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

function stripUndefined(values) {
    return lodash_fp__WEBPACK_IMPORTED_MODULE_0___default().pickBy((lodash_fp__WEBPACK_IMPORTED_MODULE_0___default().identity), values);
};


/***/ }),

/***/ 6696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Collections; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(81871);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/CollectionsPageSeo.tsx




function CollectionsPageSeo() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
        title: intl.formatMessage({
            defaultMessage: "Local Government Innovation Collections – Govlaunch",
            id: "1DDlhf"
        }),
        description: intl.formatMessage({
            defaultMessage: "Search Govlaunch Collections for local government innovation projects and technology across all departments.",
            id: "uLXEMC"
        })
    });
};

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./lib/mutations/ToggleBookmarkMutation.ts
var ToggleBookmarkMutation = __webpack_require__(19805);
// EXTERNAL MODULE: ./src/components/home/HomepageNavigation.tsx
var HomepageNavigation = __webpack_require__(72851);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/auth/useSignInModal.ts
var useSignInModal = __webpack_require__(51170);
;// CONCATENATED MODULE: ./src/components/collection/cardViewMode.ts
var ICardViewMode;
(function(ICardViewMode) {
    ICardViewMode["Bundles"] = "bundles";
    ICardViewMode["Singles"] = "singles";
    ICardViewMode["MyCollections"] = "mycollections";
    ICardViewMode["Mobile"] = "mobile";
})(ICardViewMode || (ICardViewMode = {}));

// EXTERNAL MODULE: ./src/components/collection/getInitialTabRedirect.ts
var getInitialTabRedirect = __webpack_require__(13386);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/icons/Collections/BookmarkIcon.tsx





function BookmarkIcon(_param) {
    var _viewerDidBookmark = _param.viewerDidBookmark, viewerDidBookmark = _viewerDidBookmark === void 0 ? false : _viewerDidBookmark, _bookmarkedColor = _param.bookmarkedColor, bookmarkedColor = _bookmarkedColor === void 0 ? "#28D094" : _bookmarkedColor, _notBookmarkedColor = _param.notBookmarkedColor, notBookmarkedColor = _notBookmarkedColor === void 0 ? "none" : _notBookmarkedColor, _borderColor = _param.borderColor, borderColor = _borderColor === void 0 ? "#3F4A5A" : _borderColor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "viewerDidBookmark",
        "bookmarkedColor",
        "notBookmarkedColor",
        "borderColor"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "13",
        height: "20",
        viewBox: "0 0 13 20",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.9445 2.05874C2.30562 2.05874 1.82339 2.55742 1.82339 3.12222V17.1728L6.59853 12.5483L11.3736 17.1735V3.12222C11.3736 2.55795 10.8912 2.05874 10.2525 2.05874H2.9445ZM0.411621 3.12222C0.411621 1.73505 1.5693 0.646973 2.9445 0.646973H10.2525C11.6279 0.646973 12.7854 1.73594 12.7854 3.12222V17.9849C12.7854 18.5913 12.2842 19.0446 11.7141 19.0446H11.713C11.4375 19.0442 11.1689 18.9388 10.9666 18.7447L10.9643 18.7424L6.59845 14.5137L2.23437 18.7401C2.2341 18.7404 2.23383 18.7406 2.23355 18.7409C1.92612 19.04 1.47166 19.1241 1.08007 18.9661C0.685916 18.8083 0.411499 18.4267 0.411621 17.9848V3.12222Z",
                fill: viewerDidBookmark ? bookmarkedColor : borderColor
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M2.9445 2.05874C2.30562 2.05874 1.82339 2.55742 1.82339 3.12222V17.1728L6.59853 12.5483L11.3736 17.1735V3.12222C11.3736 2.55795 10.8912 2.05874 10.2525 2.05874H2.9445Z",
                fill: viewerDidBookmark ? bookmarkedColor : notBookmarkedColor
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleBookmarkButton.tsx





function BookmarkButton(param) {
    var collection = param.collection, selfie = param.selfie, signInModal = param.signInModal, onToggleBookmark = param.onToggleBookmark;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
        label: intl.formatMessage({
            defaultMessage: "Save collection",
            id: "b+ygF6"
        }),
        bg: "teal.600",
        p: 2,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
            position: "absolute",
            top: "4px",
            right: "4px",
            width: "20px",
            height: "28px",
            "aria-label": intl.formatMessage({
                defaultMessage: "Bookmark",
                id: "Rs4kCE"
            }),
            color: "gray.400",
            zIndex: 1,
            size: "xs",
            p: 0,
            _hover: {
                color: "teal.600"
            },
            "data-intercom-target": "Bookmark collection",
            onClick: function(event) {
                event.preventDefault();
                if (selfie) {
                    onToggleBookmark(collection);
                } else {
                    signInModal.open();
                }
            },
            icon: function() {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkIcon, {
                    viewerDidBookmark: collection.viewerDidBookmark,
                    borderColor: "white"
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCardBackground.tsx



function BundleCardBackground() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "absolute",
        border: "1px",
        borderColor: "gray.400",
        width: "100%",
        height: "100%",
        top: "-4px",
        left: "-8px",
        borderRadius: "12px 12px 4px 12px",
        bg: "white"
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
;// CONCATENATED MODULE: ./components/icons/Collections/BundleCardForegroundIcon.tsx





function BundleCardForegroundIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 288 136",
        height: "288",
        width: "136",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-225.369",
                y1: "63.576",
                x2: "296.161",
                y2: "51.47",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-225.218",
                y1: "66.414",
                x2: "296.312",
                y2: "54.308",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-225.067",
                y1: "69.252",
                x2: "296.463",
                y2: "57.146",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.916",
                y1: "72.09",
                x2: "296.615",
                y2: "59.984",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.763",
                y1: "74.928",
                x2: "296.768",
                y2: "62.823",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.611",
                y1: "77.767",
                x2: "296.917",
                y2: "65.661",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.46",
                y1: "80.605",
                x2: "297.069",
                y2: "68.499",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.309",
                y1: "83.443",
                x2: "297.221",
                y2: "71.337",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.156",
                y1: "86.282",
                x2: "297.373",
                y2: "74.176",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-224.005",
                y1: "89.12",
                x2: "297.524",
                y2: "77.014",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-223.853",
                y1: "91.958",
                x2: "297.675",
                y2: "79.852",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-223.702",
                y1: "94.796",
                x2: "297.828",
                y2: "82.69",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-223.551",
                y1: "97.635",
                x2: "297.979",
                y2: "85.529",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-223.398",
                y1: "100.472",
                x2: "298.131",
                y2: "88.367",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-223.247",
                y1: "103.311",
                x2: "298.282",
                y2: "91.205",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-223.095",
                y1: "106.149",
                x2: "298.435",
                y2: "94.043",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.944",
                y1: "108.988",
                x2: "298.586",
                y2: "96.882",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.793",
                y1: "111.826",
                x2: "298.737",
                y2: "99.72",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.64",
                y1: "114.664",
                x2: "298.889",
                y2: "102.558",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.489",
                y1: "117.502",
                x2: "299.042",
                y2: "105.396",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.337",
                y1: "120.34",
                x2: "299.193",
                y2: "108.234",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.186",
                y1: "123.179",
                x2: "299.344",
                y2: "111.073",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-222.035",
                y1: "126.017",
                x2: "299.497",
                y2: "113.911",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-221.882",
                y1: "128.855",
                x2: "299.647",
                y2: "116.749",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-221.731",
                y1: "131.693",
                x2: "299.798",
                y2: "119.587",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-221.579",
                y1: "134.532",
                x2: "299.949",
                y2: "122.426",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                x: "-42.738",
                y: "-45.889",
                width: "525.94",
                height: "156.652",
                fill: "currentColor",
                transform: "matrix(0.999991, -0.004189, 0.010848, 0.999963, -183.61673, 0.923316)"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCardForeground.tsx





function BundleCardForeground(param) {
    var viewMode = param.viewMode, _color = param.color, color = _color === void 0 ? "blue.600" : _color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "absolute",
        top: 0,
        left: 0,
        color: color,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCardForegroundIcon, {
            height: viewMode === ICardViewMode.Bundles ? "136px" : "116px",
            width: "550px"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/utils/cardNameUtils.ts
function containsWordLongerThan(name, length) {
    return name.split(" ").filter(function(w) {
        return w.length > length;
    }).length > 0;
}

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCollectionCardName.tsx





function BundleCollectionCardName(param) {
    var viewMode = param.viewMode, _color = param.color, color = _color === void 0 ? "white" : _color, name = param.name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        display: "flex",
        minHeight: viewMode === ICardViewMode.Bundles ? "136px" : "116px",
        alignItems: "center",
        justifyContent: "center",
        children: [
            name.length > 50 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                bg: "gray.400",
                label: name,
                borderRadius: 10,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                    color: color || "white",
                    textAlign: "center",
                    fontSize: [
                        "2xl",
                        "xl",
                        "xl",
                        viewMode === ICardViewMode.Bundles ? "2xl" : "xl"
                    ],
                    fontWeight: "bold",
                    wordBreak: containsWordLongerThan(name, 17) ? "break-all" : "normal",
                    clamp: 3,
                    children: name
                })
            }),
            name.length <= 50 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                color: color || "white",
                textAlign: "center",
                fontSize: [
                    "2xl",
                    "xl",
                    "xl",
                    viewMode === ICardViewMode.Bundles ? "2xl" : "xl"
                ],
                fontWeight: "bold",
                wordBreak: containsWordLongerThan(name, 17) ? "break-all" : "normal",
                clamp: 3,
                children: name
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCollectionCardNewContent.tsx





function BundleCollectionCardNewContent(param) {
    var viewMode = param.viewMode;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        position: "absolute",
        bottom: viewMode === ICardViewMode.Bundles ? "12px" : "8px",
        left: viewMode === ICardViewMode.Bundles ? "12px" : "8px",
        color: "red.800",
        fontSize: [
            "lg",
            "sm",
            "md",
            "md"
        ],
        fontWeight: "semibold",
        maxWidth: viewMode === ICardViewMode.Bundles || viewMode === ICardViewMode.MyCollections ? "90px" : undefined,
        children: [
            "▸ ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "New Content",
                id: "6aSEZT"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCollectionCardTags.tsx




function BundleCollectionCardTags(param) {
    var tags = param.tags, _viewMode = param.viewMode, viewMode = _viewMode === void 0 ? ICardViewMode.Bundles : _viewMode;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
        color: "gray.900",
        fontWeight: "semibold",
        fontSize: viewMode === ICardViewMode.Bundles ? "lg" : "md",
        mt: 1,
        textAlign: "center",
        clamp: 2,
        children: tags.map(function(tag) {
            return tag.name;
        }).join(", ")
    });
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCollectionCardTotal.tsx





function BundleCollectionCardTotal(param) {
    var viewMode = param.viewMode, total = param.total;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "absolute",
        bottom: viewMode === ICardViewMode.Bundles ? "12px" : "8px",
        right: viewMode === ICardViewMode.Bundles ? "12px" : "8px",
        color: "gray.800",
        fontSize: [
            "lg",
            "sm",
            "md",
            "md"
        ],
        fontWeight: [
            "semibold",
            "normal",
            "normal",
            "normal"
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "{total} Total",
            id: "fkXl+5",
            values: {
                total: total
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/bundleCard/BundleCollectionCard.tsx















function BundleCollectionCard(param) {
    var collection = param.collection, _viewMode = param.viewMode, viewMode = _viewMode === void 0 ? ICardViewMode.Bundles : _viewMode, onToggleBookmark = param.onToggleBookmark;
    var ref, ref1;
    var selfie = (0,Auth/* useSelfie */.yD)();
    var signInModal = (0,useSignInModal/* default */.Z)();
    var totalContentCount = collection.contentCounters.groupsCount + collection.contentCounters.productsCount + collection.contentCounters.projectsCount + collection.contentCounters.storiesCount + collection.contentCounters.governmentsCount;
    var newContentCount = collection.newContentCounters ? collection.newContentCounters.groupsCount + collection.newContentCounters.productsCount + collection.newContentCounters.projectsCount + collection.newContentCounters.storiesCount + collection.newContentCounters.governmentsCount : 0;
    var redirect = (0,getInitialTabRedirect/* default */.Z)(collection.contentCounters);
    var linkHref = "/collections/[collectionSlug]/[[...tab]]";
    var linkAs = "/collections/".concat(collection.slug, "/projects");
    if (redirect) {
        linkHref = "/collections/[collectionSlug]/[[...tab]]";
        linkAs = "/collections/".concat(collection.slug, "/").concat(redirect);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: linkHref,
        as: linkAs,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            border: "none",
            borderColor: "transparent",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: [
                "100%",
                "100%",
                "100%",
                viewMode === ICardViewMode.Bundles ? "100%" : "226px"
            ],
            height: viewMode === ICardViewMode.Bundles ? "280px" : viewMode === ICardViewMode.MyCollections ? "224px" : "148px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCardBackground, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    position: "relative",
                    "data-intercom-target": "Collection card",
                    width: "100%",
                    height: "100%",
                    borderColor: "#73849D !important",
                    border: "1px",
                    borderRadius: "12px 12px 4px 12px",
                    bg: "white",
                    overflow: "hidden",
                    boxShadow: "lg",
                    _hover: {
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)"
                    },
                    children: [
                        onToggleBookmark && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkButton, {
                            collection: collection,
                            selfie: selfie,
                            signInModal: signInModal,
                            onToggleBookmark: onToggleBookmark
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCardForeground, {
                            color: (ref = collection.displayOptions) === null || ref === void 0 ? void 0 : ref.cardBackgroundColorHex,
                            viewMode: viewMode
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                            px: viewMode === ICardViewMode.Bundles || viewMode === ICardViewMode.MyCollections ? 5 : 2,
                            position: "relative",
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollectionCardName, {
                                    viewMode: viewMode,
                                    color: (ref1 = collection.displayOptions) === null || ref1 === void 0 ? void 0 : ref1.cardTitleFontColorHex,
                                    name: collection.name
                                }),
                                (viewMode === ICardViewMode.Bundles || viewMode === ICardViewMode.MyCollections) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollectionCardTags, {
                                    tags: collection.tags,
                                    viewMode: viewMode
                                })
                            ]
                        }),
                        newContentCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollectionCardNewContent, {
                            viewMode: viewMode
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollectionCardTotal, {
                            viewMode: viewMode,
                            total: totalContentCount
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(16258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(22913);
// EXTERNAL MODULE: ./node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var moment = __webpack_require__(98777);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./src/components/collection/graphql/fragments/CollectionCardFieldsFragment.ts
var CollectionCardFieldsFragment = __webpack_require__(26049);
;// CONCATENATED MODULE: ./src/components/collection/graphql/ListCollectionsQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ListAllCollections(\n    $searchQuery: String\n    $filterByType: CollectionPackaging\n    $filterByFeatured: CollectionFeaturedStatus\n    $cursor: String\n    $limit: Int = 12\n    $lastVisitDate: DateTime\n  ) {\n    listAllCollections(\n      searchQuery: $searchQuery\n      filterByPackaging: $filterByType\n      filterByFeatured: $filterByFeatured\n      cursor: $cursor\n      limit: $limit\n      filterByViewerBookmarkStatus: UNSAVED\n    ) {\n      items {\n        ...CollectionCardFields\n\n        newContentCounters(lastVisitAnchor: LAST_TRACKED_VIEWER_VISIT, lastVisitDate: $lastVisitDate) {\n          groupsCount\n          productsCount\n          projectsCount\n          storiesCount\n          governmentsCount\n        }\n      }\n      pageInfo {\n        cursor\n        hasNextPage\n      }\n      totalCount\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var ListCollectionsQuery = ((0,lib/* gql */.Ps)(_templateObject(), CollectionCardFieldsFragment/* default */.Z));

// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./components/form/resources/ShowMoreButtonWithIcon.tsx + 1 modules
var ShowMoreButtonWithIcon = __webpack_require__(38248);
;// CONCATENATED MODULE: ./src/components/collection/BundleCollections.tsx













function BundleCollections(param) {
    var query = param.query, toggleBookmark = param.toggleBookmark, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var apollo = (0,useApolloClient/* useApolloClient */.x)();
    (0,react.useEffect)(function() {
        return function() {
            apollo.query({
                fetchPolicy: "network-only",
                query: ListCollectionsQuery,
                variables: bundleVariables
            }).then(function(response) {
                if (!response.data) {
                    return;
                }
                apollo.writeQuery({
                    query: ListCollectionsQuery,
                    variables: bundleVariables,
                    data: response.data
                });
            });
        };
    }, []);
    // NOTE: do not touch
    var lastVisitDate = moment_default()().subtract(7, "days").format("YYYY-MM-DD");
    var bundleVariables = {
        filterByType: types/* ICollectionPackaging.Bundle */.vK.Bundle,
        limit: 3,
        cursor: null,
        searchQuery: (0,stringOrFirst/* default */.Z)(query),
        lastVisitDate: "".concat(lastVisitDate, "T00:00:00Z"),
        filterByFeatured: types/* ICollectionFeaturedStatus.FeaturedOnly */.hq.FeaturedOnly
    };
    var ref = (0,useQuery/* useQuery */.a)(ListCollectionsQuery, {
        notifyOnNetworkStatusChange: true,
        variables: bundleVariables
    }), bundles = ref.data, loading = ref.loading, networkStatus = ref.networkStatus, fetchMore = ref.fetchMore;
    if ((loading || networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading) && !(bundles === null || bundles === void 0 ? void 0 : bundles.listAllCollections.items.length)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            p: "168px",
            justifyContent: "center",
            display: "flex",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
        });
    }
    if (!bundles || bundles.listAllCollections.items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                columns: [
                    1,
                    2,
                    3,
                    3
                ],
                spacing: [
                    6,
                    6,
                    6,
                    "72px"
                ],
                px: [
                    4,
                    4,
                    4,
                    "109px"
                ],
                mb: 8,
                children: bundles.listAllCollections.items.map(function(bundle) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollectionCard, {
                        collection: bundle,
                        viewMode: isMobile ? ICardViewMode.Mobile : ICardViewMode.Bundles,
                        onToggleBookmark: function(param) {
                            var _id = param._id;
                            return toggleBookmark(!bundle.viewerDidBookmark, {
                                variables: {
                                    targetId: _id,
                                    targetType: types/* IBookmarkType.Collection */.Cw.Collection
                                }
                            });
                        }
                    }, bundle._id);
                })
            }),
            bundles.listAllCollections.pageInfo.hasNextPage && [
                core_networkStatus/* NetworkStatus.ready */.I.ready,
                core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore
            ].includes(networkStatus) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                display: "flex",
                justifyContent: "center",
                mt: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButtonWithIcon/* default */.Z, {
                    loading: loading,
                    onClick: function() {
                        fetchMore({
                            variables: {
                                cursor: bundles.listAllCollections.pageInfo.cursor
                            },
                            updateQuery: function(current, param) {
                                var fetchMoreResult = param.fetchMoreResult;
                                if (!fetchMoreResult || !fetchMoreResult.listAllCollections || !current.listAllCollections) {
                                    return {
                                        __typename: "Query",
                                        listAllCollections: current.listAllCollections
                                    };
                                }
                                return {
                                    __typename: "Query",
                                    listAllCollections: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current.listAllCollections), {
                                        items: current.listAllCollections.items.concat(fetchMoreResult.listAllCollections.items),
                                        pageInfo: (0,_object_spread/* default */.Z)({}, fetchMoreResult.listAllCollections.pageInfo)
                                    })
                                };
                            }
                        });
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
// EXTERNAL MODULE: ./lib/utils/stripUndefined.ts
var stripUndefined = __webpack_require__(91760);
;// CONCATENATED MODULE: ./src/components/collection/CollectionsListingPageFilters.tsx









function CollectionsListingPageFilters() {
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var inputRef = (0,react.useRef)();
    var ref = (0,react.useState)(function() {
        return Array.isArray(router.query.query) ? router.query.query[0] : router.query.query || "";
    }), searchQuery = ref[0], setSearchQuery = ref[1];
    var performSearch = (0,react.useCallback)(function(searchQuery) {
        router.push({
            pathname: router.pathname,
            query: (0,stripUndefined/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                query: searchQuery
            }))
        });
    }, [
        router.query
    ]);
    var performSearchWithDelay = (0,react.useCallback)((0,fp.debounce)(1000, performSearch), [
        performSearch
    ]);
    useUpdateEffect(function() {
        return performSearchWithDelay(searchQuery);
    }, [
        searchQuery
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        bg: [
            "none",
            "none",
            "blue.100"
        ],
        px: [
            0,
            0,
            10
        ],
        py: [
            0,
            0,
            3
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Input */.II, {
            ref: inputRef,
            "aria-label": intl.formatMessage({
                defaultMessage: "Search for collections",
                id: "EWy3CT"
            }),
            placeholder: intl.formatMessage({
                defaultMessage: "Search for collections",
                id: "EWy3CT"
            }),
            "data-intercom-target": "Search collections",
            size: "md",
            value: searchQuery,
            onKeyDown: function(event) {
                if (event.key === "Enter" && inputRef.current && inputRef.current.value) {
                    performSearch(inputRef.current.value);
                }
            },
            onChange: function(event) {
                setSearchQuery(event.target.value);
            }
        })
    });
};
function useUpdateEffect(effect) {
    var dependencies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var isInitialMount = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            return effect();
        }
    }, dependencies);
}

;// CONCATENATED MODULE: ./components/icons/Collections/MyCollectionsIcon.tsx





function MyCollectionsIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: "16",
                cy: "16",
                r: "14.75",
                stroke: "#086BE5",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.6924 13.5385C19.6924 15.5777 18.0393 17.2308 16 17.2308C13.9608 17.2308 12.3077 15.5777 12.3077 13.5385C12.3077 11.4993 13.9608 9.84619 16 9.84619C18.0393 9.84619 19.6924 11.4993 19.6924 13.5385Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.6924 13.5385C19.6924 15.5777 18.0393 17.2308 16 17.2308C13.9608 17.2308 12.3077 15.5777 12.3077 13.5385C12.3077 11.4993 13.9608 9.84619 16 9.84619C18.0393 9.84619 19.6924 11.4993 19.6924 13.5385Z",
                stroke: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                id: "path-3-inside-1",
                fill: "white",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.92313 26.9574C6.08607 22.0846 10.4688 18.4614 15.6978 18.4614C21.2912 18.4614 25.9163 22.6073 26.6678 27.9937C23.9345 30.4825 20.301 31.9999 16.3131 31.9999C11.7981 31.9999 7.73748 30.055 4.92313 26.9574Z"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4.92313 26.9574L2.00508 26.261L1.63728 27.8021L2.70271 28.9747L4.92313 26.9574ZM26.6678 27.9937L28.6877 30.2119L29.8577 29.1464L29.6391 27.5791L26.6678 27.9937ZM7.84118 27.6538C8.68914 24.1008 11.8889 21.4614 15.6978 21.4614V15.4614C9.0487 15.4614 3.48299 20.0684 2.00508 26.261L7.84118 27.6538ZM15.6978 21.4614C19.7738 21.4614 23.149 24.4835 23.6966 28.4082L29.6391 27.5791C28.6836 20.731 22.8086 15.4614 15.6978 15.4614V21.4614ZM24.648 25.7755C22.4455 27.781 19.5251 28.9999 16.3131 28.9999V34.9999C21.0769 34.9999 25.4236 33.184 28.6877 30.2119L24.648 25.7755ZM16.3131 28.9999C12.6787 28.9999 9.41328 27.4382 7.14355 24.94L2.70271 28.9747C6.06168 32.6718 10.9176 34.9999 16.3131 34.9999V28.9999Z",
                fill: "#086BE5",
                mask: "url(#path-3-inside-1)"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionBookmarkButton.tsx





function CollectionBookmarkButton(param) {
    var collection = param.collection, selfie = param.selfie, signInModal = param.signInModal, onToggleBookmark = param.onToggleBookmark;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
        bg: "teal.800",
        label: intl.formatMessage({
            defaultMessage: "Save collection",
            id: "b+ygF6"
        }),
        p: 2,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
            position: "absolute",
            top: "4px",
            right: "4px",
            width: "20px",
            height: "28px",
            "aria-label": intl.formatMessage({
                defaultMessage: "Bookmark",
                id: "Rs4kCE"
            }),
            color: "gray.400",
            zIndex: 1,
            size: "xs",
            _hover: {
                color: "teal.800"
            },
            "data-intercom-target": "Bookmark collection",
            onClick: function(event) {
                event.preventDefault();
                if (selfie) {
                    onToggleBookmark(collection);
                } else {
                    signInModal.open();
                }
            },
            icon: function() {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkIcon, {
                    viewerDidBookmark: collection.viewerDidBookmark,
                    notBookmarkedColor: "none"
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionCardName.tsx





function CollectionCardName(param) {
    var _viewMode = param.viewMode, viewMode = _viewMode === void 0 ? ICardViewMode.Singles : _viewMode, name = param.name;
    if (name.length > 50) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
            bg: "gray.400",
            label: name,
            borderRadius: 10,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                color: "gray.800",
                display: "block",
                textAlign: "center",
                clamp: 3,
                fontSize: [
                    "2xl",
                    "xl",
                    "xl",
                    viewMode === ICardViewMode.Singles ? "2xl" : "xl"
                ],
                fontWeight: "bold",
                wordBreak: containsWordLongerThan(name, 17) ? "break-all" : "normal",
                children: name
            })
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
            color: "gray.800",
            display: "block",
            textAlign: "center",
            clamp: 3,
            fontSize: [
                "2xl",
                "xl",
                "xl",
                viewMode === ICardViewMode.Singles ? "2xl" : "xl"
            ],
            fontWeight: "bold",
            wordBreak: containsWordLongerThan(name, 17) ? "break-all" : "normal",
            children: name
        });
    }
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionCardBottomCorner.tsx



function CollectionCardBottomCorner() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "absolute",
        width: "245px",
        height: "1px",
        transform: "translateY(15px) translateX(32px) rotate(-30deg)",
        borderBottom: "1px",
        borderColor: "currentColor",
        bottom: 45,
        right: -9,
        opacity: 0.25
    });
};

;// CONCATENATED MODULE: ./components/icons/Collections/CollectionCardForegroundIcon.tsx


function CollectionCardForegroundIcon(param) {
    var variant = param.variant;
    if (variant === 1) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
            width: "226px",
            height: "61",
            viewBox: "0 0 226 61",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-75.1303",
                    y1: "1.82283",
                    x2: "229.681",
                    y2: "-64.1108",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-74.4679",
                    y1: "4.88581",
                    x2: "230.344",
                    y2: "-61.0479",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-73.8051",
                    y1: "7.9488",
                    x2: "231.006",
                    y2: "-57.9849",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-73.1427",
                    y1: "11.0118",
                    x2: "231.669",
                    y2: "-54.9219",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-72.4803",
                    y1: "14.0743",
                    x2: "232.331",
                    y2: "-51.8594",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-71.8174",
                    y1: "17.1373",
                    x2: "232.994",
                    y2: "-48.7964",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-71.1551",
                    y1: "20.2003",
                    x2: "233.656",
                    y2: "-45.7334",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-70.4927",
                    y1: "23.2633",
                    x2: "234.319",
                    y2: "-42.6704",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-69.8298",
                    y1: "26.3262",
                    x2: "234.982",
                    y2: "-39.6074",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-69.1675",
                    y1: "29.3892",
                    x2: "235.644",
                    y2: "-36.5444",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-68.5046",
                    y1: "32.4522",
                    x2: "236.307",
                    y2: "-33.4814",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-67.8422",
                    y1: "35.5147",
                    x2: "236.969",
                    y2: "-30.4189",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-67.1799",
                    y1: "38.5777",
                    x2: "237.632",
                    y2: "-27.356",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-66.517",
                    y1: "41.6407",
                    x2: "238.294",
                    y2: "-24.293",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-65.8546",
                    y1: "44.7037",
                    x2: "238.957",
                    y2: "-21.23",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-65.1923",
                    y1: "47.7667",
                    x2: "239.619",
                    y2: "-18.167",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-64.5294",
                    y1: "50.8297",
                    x2: "240.282",
                    y2: "-15.104",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-63.8671",
                    y1: "53.8927",
                    x2: "240.944",
                    y2: "-12.041",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-63.2046",
                    y1: "56.9556",
                    x2: "241.607",
                    y2: "-8.97803",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-62.5418",
                    y1: "60.0181",
                    x2: "242.27",
                    y2: "-5.91553",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M58 -1L-15 50V-1H58Z",
                    fill: "currentColor"
                })
            ]
        });
    }
    if (variant === 2) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
            width: "73px",
            height: "82",
            viewBox: "0 0 73 82",
            fill: "none",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M72.5 -1L0 82V-1H72.5Z",
                fill: "currentColor"
            })
        });
    }
    if (variant === 3) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
            width: "226px",
            height: "97",
            viewBox: "0 0 226 97",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-83.7228",
                    y1: "0.181728",
                    x2: "220.774",
                    y2: "-67.1891",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-83.0459",
                    y1: "3.2413",
                    x2: "221.451",
                    y2: "-64.1296",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-82.3691",
                    y1: "6.30087",
                    x2: "222.128",
                    y2: "-61.07",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-81.6918",
                    y1: "9.36093",
                    x2: "222.805",
                    y2: "-58.01",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-81.015",
                    y1: "12.4205",
                    x2: "223.482",
                    y2: "-54.9504",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-80.3382",
                    y1: "15.4806",
                    x2: "224.159",
                    y2: "-51.8903",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-79.6609",
                    y1: "18.5401",
                    x2: "224.836",
                    y2: "-48.8308",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-78.9841",
                    y1: "21.5997",
                    x2: "225.513",
                    y2: "-45.7712",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-78.3073",
                    y1: "24.6598",
                    x2: "226.19",
                    y2: "-42.7111",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-77.63",
                    y1: "27.7193",
                    x2: "226.867",
                    y2: "-39.6516",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-76.9532",
                    y1: "30.7794",
                    x2: "227.544",
                    y2: "-36.5915",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-76.2759",
                    y1: "33.839",
                    x2: "228.221",
                    y2: "-33.5319",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-75.599",
                    y1: "36.8985",
                    x2: "228.898",
                    y2: "-30.4724",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-74.9222",
                    y1: "39.9586",
                    x2: "229.575",
                    y2: "-27.4123",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-74.2449",
                    y1: "43.0182",
                    x2: "230.252",
                    y2: "-24.3527",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-73.5681",
                    y1: "46.0782",
                    x2: "230.929",
                    y2: "-21.2927",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-72.8913",
                    y1: "49.1378",
                    x2: "231.606",
                    y2: "-18.2331",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-72.214",
                    y1: "52.1974",
                    x2: "232.283",
                    y2: "-15.1735",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-71.5372",
                    y1: "55.2574",
                    x2: "232.96",
                    y2: "-12.1135",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-70.8604",
                    y1: "58.317",
                    x2: "233.637",
                    y2: "-9.0539",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                    x1: "-70.183",
                    y1: "61.377",
                    x2: "234.314",
                    y2: "-5.99384",
                    stroke: "currentColor"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M-22.6388 23.721L146.237 -1.65949L57.4482 -74.2446L-22.6388 23.721Z",
                    fill: "currentColor"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "226px",
        height: "75px",
        viewBox: "0 0 226 75",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-131.443",
                y1: "0.507884",
                x2: "173.368",
                y2: "-65.4258",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-130.78",
                y1: "3.57087",
                x2: "174.031",
                y2: "-62.3628",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-130.118",
                y1: "6.63386",
                x2: "174.694",
                y2: "-59.2998",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-129.456",
                y1: "9.69685",
                x2: "175.356",
                y2: "-56.2368",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-128.793",
                y1: "12.7598",
                x2: "176.019",
                y2: "-53.1738",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-128.13",
                y1: "15.8228",
                x2: "176.681",
                y2: "-50.1108",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-127.468",
                y1: "18.8858",
                x2: "177.344",
                y2: "-47.0479",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-126.805",
                y1: "21.9488",
                x2: "178.006",
                y2: "-43.9849",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-126.143",
                y1: "25.0118",
                x2: "178.669",
                y2: "-40.9219",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-125.48",
                y1: "28.0743",
                x2: "179.331",
                y2: "-37.8594",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-124.817",
                y1: "31.1373",
                x2: "179.994",
                y2: "-34.7964",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-124.155",
                y1: "34.2003",
                x2: "180.656",
                y2: "-31.7334",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-123.493",
                y1: "37.2633",
                x2: "181.319",
                y2: "-28.6704",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-122.83",
                y1: "40.3262",
                x2: "181.982",
                y2: "-25.6074",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-122.167",
                y1: "43.3892",
                x2: "182.644",
                y2: "-22.5444",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-121.505",
                y1: "46.4522",
                x2: "183.307",
                y2: "-19.4814",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-120.842",
                y1: "49.5147",
                x2: "183.969",
                y2: "-16.4189",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-120.18",
                y1: "52.5777",
                x2: "184.632",
                y2: "-13.356",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-119.517",
                y1: "55.6407",
                x2: "185.295",
                y2: "-10.293",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-118.855",
                y1: "58.7037",
                x2: "185.957",
                y2: "-7.22998",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-118.192",
                y1: "61.7667",
                x2: "186.619",
                y2: "-4.16699",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-117.529",
                y1: "64.8297",
                x2: "187.282",
                y2: "-1.104",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-116.867",
                y1: "67.8927",
                x2: "187.944",
                y2: "1.95899",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-116.205",
                y1: "70.9556",
                x2: "188.607",
                y2: "5.02197",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                x1: "-115.542",
                y1: "74.0181",
                x2: "189.27",
                y2: "8.08447",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M47 -37L267 31V-37H47Z",
                fill: "currentColor"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionCardForeground.tsx




function CollectionCardForeground(param) {
    var variant = param.variant;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "absolute",
        top: 0,
        left: 0,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCardForegroundIcon, {
            variant: variant
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionCardTotal.tsx




function CollectionCardTotal(param) {
    var total = param.total;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "absolute",
        bottom: "8px",
        right: "8px",
        color: "gray.800",
        fontSize: [
            "lg",
            "sm",
            "md",
            "md"
        ],
        fontWeight: [
            "semibold",
            "normal",
            "normal",
            "normal"
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "{total} Total",
            id: "fkXl+5",
            values: {
                total: total
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionCardNewContent.tsx





function CollectionCardNewContent(param) {
    var _viewMode = param.viewMode, viewMode = _viewMode === void 0 ? ICardViewMode.Singles : _viewMode;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        position: "absolute",
        bottom: "8px",
        left: "8px",
        color: "red.800",
        fontSize: [
            "lg",
            "sm",
            "md",
            "md"
        ],
        fontWeight: "semibold",
        maxWidth: viewMode === ICardViewMode.Singles || viewMode === ICardViewMode.MyCollections ? "90px" : undefined,
        children: [
            "▸ ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "New Content",
                id: "6aSEZT"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/collection/collectionCard/CollectionCard.tsx

















function CollectionCard(_param) {
    var variant = _param.variant, _viewMode = _param.viewMode, viewMode = _viewMode === void 0 ? ICardViewMode.Singles : _viewMode, collection = _param.collection, onToggleBookmark = _param.onToggleBookmark, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "viewMode",
        "collection",
        "onToggleBookmark"
    ]);
    var ref;
    var selfie = (0,Auth/* useSelfie */.yD)();
    var signInModal = (0,useSignInModal/* default */.Z)();
    var totalContentCount = collection.contentCounters.groupsCount + collection.contentCounters.productsCount + collection.contentCounters.projectsCount + collection.contentCounters.storiesCount + collection.contentCounters.governmentsCount;
    var newContentCount = collection.newContentCounters ? collection.newContentCounters.groupsCount + collection.newContentCounters.productsCount + collection.newContentCounters.projectsCount + collection.newContentCounters.storiesCount + collection.newContentCounters.governmentsCount : 0;
    var redirect = (0,getInitialTabRedirect/* default */.Z)(collection.contentCounters);
    var linkHref = "/collections/[collectionSlug]/[[...tab]]";
    var linkAs = "/collections/".concat(collection.slug, "/projects");
    if (redirect) {
        linkHref = "/collections/[collectionSlug]/[[...tab]]";
        linkAs = "/collections/".concat(collection.slug, "/").concat(redirect);
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: linkHref,
        as: linkAs,
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
            border: "none",
            borderColor: "transparent",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: [
                "100%",
                "100%",
                "100%",
                "226px"
            ],
            height: viewMode === ICardViewMode.Mobile ? "148px" : "224px",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                position: "relative",
                width: "100%",
                height: "100%",
                bg: "white",
                color: ((ref = collection.displayOptions) === null || ref === void 0 ? void 0 : ref.cardBackgroundColorHex) || "blue.600",
                border: "1px",
                borderColor: "gray.100",
                borderRadius: "12px 12px 4px 12px",
                boxShadow: "lg",
                _hover: {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)"
                },
                overflow: "hidden",
                display: "flex"
            }, props), {
                children: [
                    onToggleBookmark && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionBookmarkButton, {
                        collection: collection,
                        selfie: selfie,
                        signInModal: signInModal,
                        onToggleBookmark: onToggleBookmark
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCardForeground, {
                        variant: variant
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        px: viewMode === ICardViewMode.Mobile ? 2 : 5,
                        justifyContent: "center",
                        flex: 1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCardName, {
                            viewMode: viewMode,
                            name: collection.name
                        })
                    }),
                    newContentCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCardNewContent, {
                        viewMode: viewMode
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCardTotal, {
                        total: totalContentCount
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCardBottomCorner, {})
                ]
            }))
        })
    });
};

// EXTERNAL MODULE: ./src/components/collection/graphql/SelfieCollectionsQuery.ts
var SelfieCollectionsQuery = __webpack_require__(82207);
;// CONCATENATED MODULE: ./components/icons/Collections/NoSavedCollectionsIcon.tsx





function NoSavedCollectionsIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "66",
        height: "61",
        viewBox: "0 0 66 61",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M7.25 0.875C5.50278 0.875 3.84103 1.4949 2.66797 2.66797C1.4949 3.84103 0.875 5.50278 0.875 7.25V15.75V24.25V49.75C0.875 51.4972 1.4949 53.159 2.66797 54.332C3.84103 55.5051 5.50278 56.125 7.25 56.125H49.75C51.4972 56.125 53.159 55.5051 54.332 54.332C55.5051 53.159 56.125 51.4972 56.125 49.75V26.375V24.25V20V15.75C56.125 14.0028 55.5051 12.341 54.332 11.168C53.159 9.9949 51.4972 9.375 49.75 9.375H26.375V7.25C26.375 5.50278 25.7551 3.84103 24.582 2.66797C23.409 1.4949 21.7472 0.875 20 0.875H7.25ZM7.25 5.125H20C20.8028 5.125 21.2627 5.35841 21.5772 5.67285C21.8916 5.98729 22.125 6.44722 22.125 7.25V9.375C22.125 10.4847 22.5274 11.6202 23.3286 12.4214C24.1298 13.2226 25.2653 13.625 26.375 13.625H49.75C50.5528 13.625 51.0127 13.8584 51.3272 14.1728C51.6416 14.4873 51.875 14.9472 51.875 15.75V18.2236C51.1988 18.0082 50.4868 17.875 49.75 17.875H20H15.75C14.0028 17.875 12.341 18.4949 11.168 19.668C9.9949 20.841 9.375 22.5028 9.375 24.25V28.5V32.75V49.75C9.375 50.5528 9.14159 51.0127 8.82715 51.3271C8.51271 51.6416 8.05278 51.875 7.25 51.875C6.44722 51.875 5.98729 51.6416 5.67285 51.3271C5.35842 51.0127 5.125 50.5528 5.125 49.75V24.25V15.75V7.25C5.125 6.44722 5.35842 5.98729 5.67285 5.67285C5.98729 5.35842 6.44722 5.125 7.25 5.125ZM15.75 22.125H20H49.75C50.5528 22.125 51.0127 22.3584 51.3272 22.6728C51.6416 22.9873 51.875 23.4472 51.875 24.25V26.375V49.75C51.875 50.5528 51.6416 51.0127 51.3272 51.3271C51.0127 51.6416 50.5528 51.875 49.75 51.875H13.2764C13.4918 51.1988 13.625 50.4868 13.625 49.75V32.75V28.5V24.25C13.625 23.4472 13.8584 22.9873 14.1729 22.6728C14.4873 22.3584 14.9472 22.125 15.75 22.125Z",
                fill: "url(#paint0_linear)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                x: "23",
                y: "28",
                width: "43",
                height: "33",
                rx: "4",
                fill: "url(#paint1_linear)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M46.5825 46.4204L52.8514 46.4732C54.0053 46.4826 54.9484 45.5552 54.9581 44.4016C54.9683 43.2472 54.0405 42.3037 52.8859 42.2942L46.6177 42.2413L46.6701 35.973C46.6801 34.8185 45.7523 33.8749 44.5978 33.8657C43.4443 33.856 42.5011 34.7834 42.4911 35.9373L42.4386 42.2062L36.1697 42.1533C35.0162 42.1435 34.0726 43.0713 34.0626 44.2252C34.0528 45.3794 34.9806 46.3229 36.1348 46.3326L42.4035 46.3852L42.3506 52.6538C42.341 53.8081 43.2688 54.7516 44.4229 54.7612C45.5768 54.7706 46.5204 53.8427 46.53 52.6893L46.5825 46.4204Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "paint0_linear",
                        x1: "1.07213",
                        y1: "52.6252",
                        x2: "46.7359",
                        y2: "3.44112",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#084FE5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#28D094"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "paint1_linear",
                        x1: "23.1534",
                        y1: "58.9097",
                        x2: "49.0037",
                        y2: "22.6292",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#084FE5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#28D094"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/collection/NoSavedCollections.tsx







function NoSavedCollections() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            "data-intercom-target": "My collections",
            id: MY_COLLECTIONS_ID,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                        fontSize: "xl",
                        display: "flex",
                        fontWeight: "bold",
                        color: "blue.600",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyCollectionsIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 16,
                                    textTransform: "uppercase"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "My Collections",
                                    id: "Hbk7yA"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    mt: 8,
                    bg: "white",
                    borderRadius: "md",
                    border: "1px",
                    borderColor: "gray.100",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: "40px",
                    "data-intercom-target": "My collections",
                    mr: [
                        0,
                        0,
                        0,
                        12
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoSavedCollectionsIcon, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            fontSize: "xl",
                            display: "flex",
                            fontWeight: "bold",
                            color: "gray.900",
                            ml: 6,
                            textTransform: "uppercase",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "No Saved Collections",
                                id: "JYfNfu"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/MyCollections.tsx

















var MY_COLLECTIONS_ID = "my_collections";
function MyCollections(param) {
    var query = param.query, toggleBookmark = param.toggleBookmark, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    // NOTE: do not touch
    var lastVisitDate = moment_default()().subtract(7, "days").format("YYYY-MM-DD");
    var ref = (0,useQuery/* useQuery */.a)(SelfieCollectionsQuery/* default */.Z, {
        notifyOnNetworkStatusChange: true,
        variables: {
            searchQuery: (0,stringOrFirst/* default */.Z)(query),
            lastVisitDate: "".concat(lastVisitDate, "T00:00:00Z"),
            cursor: null
        }
    }), data = ref.data, loading = ref.loading, fetchMore = ref.fetchMore, networkStatus = ref.networkStatus;
    if ((loading || networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading) && !(data === null || data === void 0 ? void 0 : data.listAllCollections.items.length)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            p: "84px",
            justifyContent: "center",
            display: "flex",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
        });
    }
    if (!data || !data.listAllCollections || data.listAllCollections.items.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
            px: 6,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoSavedCollections, {})
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
        "data-intercom-target": "My collections",
        id: MY_COLLECTIONS_ID,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
            px: 6,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                        fontSize: "xl",
                        display: "flex",
                        fontWeight: "bold",
                        color: "blue.600",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyCollectionsIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 16,
                                    textTransform: "uppercase"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "My Collections ({totalCount})",
                                    id: "ymf3bk",
                                    values: {
                                        totalCount: data.listAllCollections.totalCount
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    mt: 8,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                            columns: [
                                1,
                                2,
                                3,
                                4
                            ],
                            spacingX: [
                                6,
                                6,
                                6,
                                "86px"
                            ],
                            spacingY: "44px",
                            mr: [
                                0,
                                0,
                                0,
                                12
                            ],
                            children: data.listAllCollections.items.map(function(collection, index) {
                                if (collection.packaging === types/* ICollectionPackaging.Single */.vK.Single) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCard, {
                                        collection: collection,
                                        viewMode: isMobile ? ICardViewMode.Mobile : ICardViewMode.MyCollections,
                                        variant: index % 3 + 1,
                                        onToggleBookmark: function(param) {
                                            var _id = param._id;
                                            return toggleBookmark(!collection.viewerDidBookmark, {
                                                variables: {
                                                    targetId: _id,
                                                    targetType: types/* IBookmarkType.Collection */.Cw.Collection
                                                }
                                            });
                                        }
                                    }, collection._id);
                                }
                                if (collection.packaging === types/* ICollectionPackaging.Bundle */.vK.Bundle) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollectionCard, {
                                        viewMode: isMobile ? ICardViewMode.Mobile : ICardViewMode.MyCollections,
                                        collection: collection,
                                        onToggleBookmark: function(param) {
                                            var _id = param._id;
                                            return toggleBookmark(!collection.viewerDidBookmark, {
                                                variables: {
                                                    targetId: _id,
                                                    targetType: types/* IBookmarkType.Collection */.Cw.Collection
                                                }
                                            });
                                        }
                                    }, collection._id);
                                }
                                return null;
                            })
                        }),
                        data.listAllCollections.pageInfo.hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: "flex",
                            justifyContent: "center",
                            mt: 6,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButtonWithIcon/* default */.Z, {
                                loading: loading,
                                onClick: function() {
                                    fetchMore({
                                        variables: {
                                            cursor: data === null || data === void 0 ? void 0 : data.listAllCollections.pageInfo.cursor
                                        },
                                        updateQuery: function(current, param) {
                                            var fetchMoreResult = param.fetchMoreResult;
                                            if (!fetchMoreResult || !fetchMoreResult.listAllCollections || !current.listAllCollections) {
                                                return {
                                                    __typename: "Query",
                                                    listAllCollections: current.listAllCollections
                                                };
                                            }
                                            return {
                                                __typename: "Query",
                                                listAllCollections: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current.listAllCollections), {
                                                    items: current.listAllCollections.items.concat(fetchMoreResult.listAllCollections.items),
                                                    pageInfo: (0,_object_spread/* default */.Z)({}, fetchMoreResult.listAllCollections.pageInfo)
                                                })
                                            };
                                        }
                                    });
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
function ScrollToMyCollections() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
        ml: "auto",
        mb: 2,
        onClick: function(event) {
            var node = document.getElementById(MY_COLLECTIONS_ID);
            if (node) {
                node.scrollIntoView({
                    behavior: "smooth"
                });
            }
            event.preventDefault();
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "My Collections",
                id: "Hbk7yA"
            }),
            " >>"
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/collection/SingleCollections.tsx













function SingleCollections(param) {
    var query = param.query, toggleBookmark = param.toggleBookmark, isMobile = param.isMobile;
    var apollo = (0,useApolloClient/* useApolloClient */.x)();
    (0,react.useEffect)(function() {
        return function() {
            apollo.query({
                fetchPolicy: "network-only",
                query: ListCollectionsQuery,
                variables: variables
            }).then(function(response) {
                if (!response.data) {
                    return;
                }
                apollo.writeQuery({
                    query: ListCollectionsQuery,
                    variables: variables,
                    data: response.data
                });
            });
        };
    }, []);
    // NOTE: do not touch
    var lastVisitDate = moment_default()().subtract(7, "days").format("YYYY-MM-DD");
    var variables = {
        filterByType: types/* ICollectionPackaging.Single */.vK.Single,
        limit: 12,
        cursor: null,
        searchQuery: (0,stringOrFirst/* default */.Z)(query),
        lastVisitDate: "".concat(lastVisitDate, "T00:00:00Z"),
        filterByFeatured: types/* ICollectionFeaturedStatus.NotFeatured */.hq.NotFeatured
    };
    var ref = (0,useQuery/* useQuery */.a)(ListCollectionsQuery, {
        notifyOnNetworkStatusChange: true,
        variables: variables
    }), collections = ref.data, loading = ref.loading, networkStatus = ref.networkStatus, fetchMore = ref.fetchMore;
    if ((loading || networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading) && !(collections === null || collections === void 0 ? void 0 : collections.listAllCollections.items.length)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            p: "168px",
            justifyContent: "center",
            display: "flex",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
        });
    }
    if (!collections || collections.listAllCollections.items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (collections.listAllCollections.items.length || 0) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            bg: "white",
            py: "36px",
            mt: 5,
            pb: "80px",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                px: 6,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                        columns: [
                            1,
                            2,
                            3,
                            4
                        ],
                        spacingX: [
                            6,
                            6,
                            6,
                            "86px"
                        ],
                        spacingY: "44px",
                        mr: [
                            0,
                            0,
                            0,
                            12
                        ],
                        children: collections === null || collections === void 0 ? void 0 : collections.listAllCollections.items.map(function(collection, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionCard, {
                                "data-intercom-target": index === 0 ? "First collection" : "Collection card",
                                collection: collection,
                                variant: index % 3 + 1,
                                viewMode: isMobile ? ICardViewMode.Mobile : ICardViewMode.Singles,
                                onToggleBookmark: function(param) {
                                    var _id = param._id;
                                    return toggleBookmark(!collection.viewerDidBookmark, {
                                        variables: {
                                            targetId: _id,
                                            targetType: types/* IBookmarkType.Collection */.Cw.Collection
                                        }
                                    });
                                }
                            }, collection._id);
                        })
                    }),
                    collections.listAllCollections.pageInfo.hasNextPage && [
                        core_networkStatus/* NetworkStatus.ready */.I.ready,
                        core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore
                    ].includes(networkStatus) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        display: "flex",
                        justifyContent: "center",
                        mt: 6,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButtonWithIcon/* default */.Z, {
                            loading: loading,
                            onClick: function() {
                                fetchMore({
                                    variables: {
                                        cursor: collections.listAllCollections.pageInfo.cursor
                                    },
                                    updateQuery: function(current, param) {
                                        var fetchMoreResult = param.fetchMoreResult;
                                        if (!fetchMoreResult || !fetchMoreResult.listAllCollections || !current.listAllCollections) {
                                            return {
                                                __typename: "Query",
                                                listAllCollections: current.listAllCollections
                                            };
                                        }
                                        return {
                                            __typename: "Query",
                                            listAllCollections: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current.listAllCollections), {
                                                items: current.listAllCollections.items.concat(fetchMoreResult.listAllCollections.items),
                                                pageInfo: (0,_object_spread/* default */.Z)({}, fetchMoreResult.listAllCollections.pageInfo)
                                            })
                                        };
                                    }
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/pages/CollectionsListingPage.tsx















function CollectionsListingPage() {
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var selfie = (0,Auth/* useSelfie */.yD)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleBookmarkMutation/* default */.Z), 1), toggleBookmark = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsPageSeo, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomepageNavigation/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                children: [
                    isMobile && selfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollToMyCollections, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsListingPageFilters, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        pt: isMobile ? 20 : 50,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            mb: 6,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BundleCollections, {
                                query: router.query.query || "",
                                toggleBookmark: function(_bookmarked, param) {
                                    var variables = param.variables;
                                    toggleBookmark({
                                        variables: variables,
                                        refetchQueries: [
                                            "SelfieCollections"
                                        ]
                                    });
                                },
                                isMobile: isMobile
                            })
                        })
                    })
                ]
            }),
            selfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                mb: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyCollections, {
                    query: router.query.query || "",
                    toggleBookmark: function(_bookmarked, param) {
                        var variables = param.variables;
                        toggleBookmark({
                            variables: variables,
                            refetchQueries: [
                                "ListAllCollections",
                                "SelfieCollections"
                            ]
                        });
                    },
                    isMobile: isMobile
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SingleCollections, {
                query: router.query.query || "",
                toggleBookmark: function(_bookmarked, param) {
                    var variables = param.variables;
                    toggleBookmark({
                        variables: variables,
                        refetchQueries: [
                            "SelfieCollections"
                        ]
                    });
                },
                isMobile: isMobile
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
;// CONCATENATED MODULE: ./pages/collections.tsx




function Collections() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
        pb: 0,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsListingPage, {})
    });
};


/***/ }),

/***/ 51170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSignInModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _src_components_auth_SignInModalStateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31480);


function useSignInModal() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_src_components_auth_SignInModalStateContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return {
        open: context.open,
        close: context.close,
        toggle: context.toggleOpen,
        isOpen: context.isOpen
    };
};


/***/ }),

/***/ 13386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getInitialTabRedirect; }
/* harmony export */ });
function getInitialTabRedirect(counters) {
    if (counters.projectsCount > 0) {
        return null;
    }
    if (counters.storiesCount > 0) {
        return "stories";
    }
    if (counters.groupsCount > 0) {
        return "discussions";
    }
    if (counters.productsCount > 0) {
        return "products";
    }
    if (counters.governmentsCount > 0) {
        return "governments";
    }
    return null;
};


/***/ }),

/***/ 82207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _src_components_collection_graphql_fragments_CollectionCardFieldsFragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26049);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query SelfieCollections($cursor: String, $searchQuery: String, $lastVisitDate: DateTime) {\n    listAllCollections(filterByViewerBookmarkStatus: SAVED, limit: 4, cursor: $cursor, searchQuery: $searchQuery) {\n      items {\n        ...CollectionCardFields\n        newContentCounters(lastVisitAnchor: LAST_TRACKED_VIEWER_VISIT, lastVisitDate: $lastVisitDate) {\n          groupsCount\n          productsCount\n          projectsCount\n          storiesCount\n          governmentsCount\n        }\n      }\n      pageInfo {\n        cursor\n        hasNextPage\n      }\n      totalCount\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _src_components_collection_graphql_fragments_CollectionCardFieldsFragment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 26049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CollectionCardFields on Collection {\n    _id\n    name\n    slug\n    packaging\n    tags {\n      _id\n      name\n    }\n    viewerDidBookmark\n    contentCounters {\n      groupsCount\n      productsCount\n      projectsCount\n      storiesCount\n      governmentsCount\n    }\n    displayOptions {\n      cardBackgroundColorHex\n      cardTitleFontColorHex\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 72851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomepageNavigation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27068);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69057);










function HomepageNavigation() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var tabsRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createRef)();
    var viewer = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_4__/* .useSelfie */ .yD)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var pathname = router === null || router === void 0 ? void 0 : router.pathname;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!tabsRef.current) {
            return;
        }
        if (pathname === "/vendors") {
            tabsRef.current.scrollLeft = 200;
        }
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                overflow: "hidden",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: [
                        "flex",
                        "flex",
                        "none"
                    ],
                    overflowX: [
                        "scroll",
                        "scroll",
                        "auto"
                    ],
                    ref: tabsRef,
                    alignItems: "center",
                    justifyContent: "space-between",
                    bg: "white",
                    mb: 2,
                    px: 2,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/collections",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    css: {
                                        marginLeft: 4
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    defaultMessage: "Collections",
                                    id: "ulh3kf"
                                }),
                                active: pathname === "/" || pathname === "/collections"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/governments",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        d: "M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    defaultMessage: "Governments",
                                    id: "qnQX9U"
                                }),
                                active: pathname === "/governments"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/vendors",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    id: "RilevA",
                                    defaultMessage: "Vendors"
                                }),
                                active: pathname === "/vendors"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .PageGridContainer */ .pf, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: [
                        "none",
                        "none",
                        "flex"
                    ],
                    justifyContent: "flex-start",
                    alignItems: "center",
                    mb: 8,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                defaultMessage: "Collections",
                                id: "ulh3kf"
                            }),
                            href: viewer ? "/" : "/collections",
                            active: pathname === "/" || pathname === "/collections"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    d: "M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                defaultMessage: "Governments",
                                id: "qnQX9U"
                            }),
                            href: "/governments",
                            active: pathname === "/governments"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                id: "RilevA",
                                defaultMessage: "Vendors"
                            }),
                            href: "/vendors",
                            active: pathname === "/vendors"
                        })
                    ]
                })
            })
        ]
    });
};
function NavigationItem(param) {
    var icon = param.icon, label = param.label, href = param.href, active = param.active;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
            as: "a",
            display: "flex",
            alignItems: "center",
            mr: 6,
            color: active ? "blue.600" : "gray.800",
            mt: [
                4,
                4,
                0
            ],
            children: [
                icon,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                    fontSize: "md",
                    fontWeight: "semibold",
                    ml: 2,
                    as: active ? "h1" : "p",
                    children: label
                })
            ]
        })
    });
}
var MobileNavigationItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var icon = _param.icon, label = _param.label, active = _param.active, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "icon",
        "label",
        "active"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "a",
        color: active ? "blue.600" : "gray.800",
        display: "flex",
        flexDirection: [
            "column",
            "column",
            "row"
        ],
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "72px",
        borderTop: "1px",
        borderTopWidth: "5px",
        py: 2,
        px: [
            "8px",
            "8px",
            "24px"
        ],
        borderColor: active ? "blue.600" : "transparent",
        ref: ref,
        _hover: {
            bg: "blue.50"
        }
    }, props), {
        children: [
            icon,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                fontWeight: "semibold",
                fontSize: [
                    "md",
                    "md",
                    "lg"
                ],
                whiteSpace: "nowrap",
                mt: 1,
                children: label
            })
        ]
    }));
});
MobileNavigationItem.displayName = "MobileNavigationItem";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,9932,9774,2888,179], function() { return __webpack_exec__(72653); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);